import React from 'react';
import PropTypes from 'prop-types';
import {trackEvent} from '../../utils/tracking.js';
import './style.scss';
import { withGigCardContext } from '../gig_card_context';

const Title = ({ gigUrl, caption, cardType, cardSize, onLinkClick, tabTarget='_self' }) => {
    const onClick = (e) => {
        trackEvent('title', cardType, cardSize);
        onLinkClick(e);
    };

    return (
        <a href={gigUrl}
            onClick={onClick}
            className="gig-link-main js-gig-card-imp-data"
            rel="nofollow"
            title={caption}
            target={tabTarget}>

            <h3>{caption}</h3>
        </a>
    );
};

Title.propTypes = {
    gigUrl: PropTypes.string,
    caption: PropTypes.string,
    cardType: PropTypes.string,
    onLinkClick: PropTypes.func,
    tabTarget: PropTypes.string
};

Title.defaultProps = {
    onLinkClick: () => null
};

const contextSelector = ({ cardType, cardSize }) => ({ cardType, cardSize });

export default withGigCardContext(contextSelector)(Title);



// WEBPACK FOOTER //
// ./src/shared/title/index.js